"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { ComponentProps } from "react";
import { floorPlanDetail } from "../../../../public/images/logos";
import {
  matterportFlat,
  matterportHotel,
  matterportMuseum,
  matterportProperty,
  matterportRetail,
  matterportYacht,
} from "../../../../public/images/three-sixty";

type ServiceObjectsBlocksProps = ComponentProps<typeof Image> & {
  title: string;
};

const Block = ({ ...props }: ServiceObjectsBlocksProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div className="bg-card flex h-40 w-40 flex-col items-center justify-center border">
        <Image
          src={props.src}
          alt={props.alt}
          className="h-auto w-auto object-contain"
        />
      </div>
      <span className="text-ring text-xl font-medium">{props.title}</span>
    </div>
  );
};

const ServiceObjects = () => {
  const t = useTranslations("threeSixtyService.serviceObjects");
  const tC = useTranslations("common");

  return (
    <div className="bg-secondary">
      <div className="gs--page-column py-16">
        <FeatureHighlight
          src={floorPlanDetail}
          alt={"Grundriss Detail Icon der Grundriss Schmiede"}
          title={t("title")}
          text={""}
        />

        <div className="s:grid-rows-3 mt-5 grid grid-flow-col grid-rows-6 justify-evenly gap-y-15 md:grid-rows-2">
          <Block
            src={matterportProperty}
            alt={"Icon Matterport Immobilienverkauf"}
            title={tC("propertySale")}
          />
          <Block
            src={matterportRetail}
            alt={"Icon Matterport Einzelhandel"}
            title={tC("retailStore")}
          />
          <Block
            src={matterportFlat}
            alt={"Icon Matterport Ferienwohnung"}
            title={tC("vacationApt")}
          />
          <Block
            src={matterportHotel}
            alt={"Icon Matterport Hotel"}
            title={tC("hotels")}
          />
          <Block
            src={matterportYacht}
            alt={"Icon Matterport Yacht"}
            title={tC("yacht")}
          />
          <Block
            src={matterportMuseum}
            alt={"Icon Matterport Museum"}
            title={tC("museums")}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceObjects;
